module.exports = __webpack_public_path__ + "img/ecf51a27ee400095677682c466113d38.png";